// src/contexts/GlobalContext.js
import React, { createContext, useState, useEffect } from 'react';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [resultsPerPage, setResultsPerPage] = useState(() => {
        const saved = localStorage.getItem('resultsPerPage');
        return saved ? Number(saved) : 10;
    });
    const [isLoggedIn, setIsLoggedIn] = useState(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn');
        return storedIsLoggedIn === 'true';
    });
    
    const [userLevel, setUserLevel] = useState(() => {
        return localStorage.getItem('userLevel') || '3';
    });

    const [globalUserName, setGlobalUsername] = useState(() => {
        return localStorage.getItem('username') || '';
    });

    const [userFullName, setUserFullName] = useState(() => {
        return localStorage.getItem('userFullName') || '3';
    });
    
    useEffect(() => {
        localStorage.setItem('isLoggedIn', isLoggedIn);
        localStorage.setItem('userLevel', userLevel);
    }, [isLoggedIn, userLevel]);
    
    useEffect(() => {
        localStorage.setItem('resultsPerPage', resultsPerPage);
    }, [resultsPerPage]);

    return (
        <GlobalContext.Provider value={{ 
            resultsPerPage,
            setResultsPerPage,
            isLoggedIn,
            setIsLoggedIn,
            userLevel,
            setUserLevel,
            globalUserName,
            setGlobalUsername,
            userFullName,
            setUserFullName,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};
